import React from 'react';

const Footer = (props) => {
    return (
        <div style={{textAlign: "center"}}>
            <p>{props.footer.ProductName + " " + props.footer.ByWellSource}</p>
        </div>
    )
}

export default Footer